// extracted by mini-css-extract-plugin
export default {"opis":"Screen02_opis__9mB9E","bottle":"Screen02_bottle__IUV2z","rotating":"Screen02_rotating__ewSCF","start":"Screen02_start__1qqdt","startact":"Screen02_startact__BWgGh"};